export function searchFilterProducts(products, searchTerm, statusFilter) {
  if (!products || products.length === 0) return [];

  // sanitize search input
  const term = searchTerm
    .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  return products.filter((product) => {
    const name = typeof product.productName === "string"
      ? product.productName.toLowerCase()
      : "";

    const category = typeof product.productCategory === "string"
      ? product.productCategory.toLowerCase()
      : "";

    const status = typeof product.productStatus === "string"
      ? product.productStatus.toLowerCase()
      : "";

    const matchesSearch =
      !term || name.includes(term) || category.includes(term);

    const matchesStatus =
      statusFilter === "All" || status === statusFilter.toLowerCase();

    return matchesSearch && matchesStatus;
  });
}
